import { useAuth0 } from '@auth0/auth0-react'
import { useState, useEffect, useContext, createContext } from 'react'
import { UserContext } from './user-context'
import {
    getDefaultEndDate
} from '../utilities/general-utils'
import { svc_getUserPreference } from '../services/user.service'
import * as Preferences from '../constants/USER_PREFERENCE';
import { dateHandler } from '../utilities/date-utils'

const InputVarsContext = createContext(null)

const varsDefaultState = {
    dateRange: {
        startDate: null,
        endDate: null
    },
}

const InputVarsProvider = ({ children }) => {
    const { getAccessTokenSilently } = useAuth0()
    const { ddUser } = useContext(UserContext)
    const [userPreferenceRangeYears, setUserPreferenceRangeYears] = useState(null)
    const [vars, setVars] = useState(varsDefaultState);

    const getUserPreferenceRangeYears = async () => {
        const accessToken = await getAccessTokenSilently();
        const preferenceKey = Preferences.PREF_KEY.FORECAST_RANGE_YEARS;
        const defaultPreferenceValue = Preferences.PREF_DEFAULT[preferenceKey];
        let rangeValue;

        const { data, error } = await svc_getUserPreference(accessToken, ddUser.id, preferenceKey);

        if (error || !data || data.length === 0) {
            rangeValue = defaultPreferenceValue;
        } else {
            rangeValue = data[0].preference_value;
        }

        setUserPreferenceRangeYears(rangeValue);
        setVars({
            ...vars,
            dateRange: {
                startDate: dateHandler.toZeroHoursFormat(new Date()),
                endDate: getDefaultEndDate(
                    dateHandler.toZeroHoursFormat(new Date()),
                    parseInt(rangeValue)
                )
            }
        })
    }

    useEffect(() => {
        if (ddUser && !userPreferenceRangeYears) {
            getUserPreferenceRangeYears();
        }
    }, [ddUser, userPreferenceRangeYears])

    return (
        <InputVarsContext.Provider value={{ vars, setVars }}>
            {children}
        </InputVarsContext.Provider>
    )
}


export { InputVarsContext, InputVarsProvider }